import React from "react";

export default function IngredientModal({
  isOpen,
  onClose,
  title,
  searchTerm,
  setSearchTerm,
  searchTescoProducts,
  searchLoading,
  searchError,
  searchResults,
  setSearchResults,
  onProductSelect
}) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full relative">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl"
          onClick={onClose}
          title="Close"
        >
          ×
        </button>
        <h2 className="text-lg font-semibold mb-2">{title}</h2>
        <input
          type="text"
          placeholder="Search Tesco for products"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && searchTescoProducts()}
          className="border p-2 w-full mb-2"
          autoFocus
        />
        <button
          onClick={searchTescoProducts}
          disabled={searchLoading || !searchTerm.trim()}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50 mb-2"
        >
          {searchLoading ? 'Searching...' : 'Search'}
        </button>
        {searchResults.length > 0 && setSearchResults && (
          <div className="flex gap-2 my-2">
            <button
              onClick={() => setSearchResults([...searchResults].sort((a, b) => parseFloat(a.price.replace('£','')) - parseFloat(b.price.replace('£',''))))}
              className="bg-gray-200 px-3 py-1 rounded text-sm hover:bg-gray-300"
            >
              Price: Low to High
            </button>
            <button
              onClick={() => setSearchResults([...searchResults].sort((a, b) => parseFloat(b.price.replace('£','')) - parseFloat(a.price.replace('£',''))))}
              className="bg-gray-200 px-3 py-1 rounded text-sm hover:bg-gray-300"
            >
              Price: High to Low
            </button>
          </div>
        )}
        {searchError && <p className="text-red-600 mt-2">Error: {searchError}</p>}
        <div className="max-h-64 overflow-auto mt-2">
          {searchResults.length === 0 && !searchLoading && <p className="text-gray-500">No results found</p>}
          {searchResults.map((product, i) => (
            <div key={i} className="flex items-center gap-3 border-b py-2 cursor-pointer hover:bg-gray-100"
              onClick={() => onProductSelect(product)}
            >
              {product.image && <img src={product.image} alt={product.title} className="w-12 h-12 object-contain" />}
              <div className="flex-1">
                <div className="font-medium">{product.title}</div>
                <div className="text-green-700 font-bold">{product.price}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
